import { Ruler, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SIZE_GUIDE } from "@/constants/testIds";
import { trackEvent } from "@/lib/analytics";

export default function SizeGuideModal({ open, onOpenChange }) {
  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        onOpenChange(v);
        if (v) trackEvent("hoodie_size_guide_opened", {});
      }}
    >
      <DialogContent
        data-testid={SIZE_GUIDE.modal}
        className="bg-[#111] border-white/10 text-white max-w-lg max-h-[85vh] overflow-y-auto"
      >
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-tight text-2xl flex items-center gap-2">
            <Ruler size={18} className="text-[#FF6B00]" /> Find Your Fit
          </DialogTitle>
          <DialogDescription className="text-white/60">
            Pickle Wall™ performance hoodies are designed for a clean, athletic everyday fit.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-xl border border-white/10 bg-white/5 p-5 text-center" data-testid="size-guide-measurements-pending">
          <p className="text-sm font-bold uppercase tracking-wider text-[#FF6B00]">Size measurements coming soon</p>
          <p className="mt-2 text-xs text-white/50">
            Exact chest, length and sleeve measurements per size will be published here once our manufacturer's
            garment spec sheet is finalized.
          </p>
        </div>

        <div className="mt-2">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF6B00] mb-2">Fit Notes</div>
          <ul className="space-y-1.5 text-sm text-white/70 list-disc list-inside">
            <li>Athletic everyday fit</li>
            <li>For a relaxed fit, consider sizing up</li>
            <li>If you're between sizes, choose the larger size</li>
            <li>Measurements may vary slightly by garment</li>
          </ul>
        </div>

        <Link
          to="/contact"
          data-testid={SIZE_GUIDE.contactLink}
          className="mt-2 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-[#FF6B00] hover:text-[#ff8a3d]"
        >
          <MessageCircle size={14} /> Still not sure? Contact us and we&apos;ll help you choose.
        </Link>
      </DialogContent>
    </Dialog>
  );
}
